import React, { Component } from "react";
import { Button as _Button } from "semantic-ui-react";

import "./button.css";

class Button extends Component {
  render() {
    return (
      <_Button className="theme-button" {...this.props}>
        {this.props.children}
      </_Button>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/views/components/button/index.js